import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { Checkbox } from "antd";
import { AppButton, AppInput } from "components/antd-ui";
import { ChangeEvent, FormEvent, useState } from "react";
import { Link } from "react-router-dom";

type LoginFormValues = {
  username: string;
  password: string;
};

type LoginFormProps = {
  loading?: boolean;
  onSubmit?: (values: LoginFormValues) => void | Promise<void>;
};

const LoginForm = ({ loading = false, onSubmit }: LoginFormProps) => {
  const [form, setForm] = useState<LoginFormValues>({
    username: "",
    password: "",
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await onSubmit?.(form);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-5">
        <AppInput
          label="Username"
          name="username"
          type="text"
          id="username"
          value={form.username}
          placeholder="your username"
          prefix={<MailOutlined />}
          size="large"
          onChange={handleChange}
        />
      </div>

      <div className="mb-5">
        <AppInput
          label="Password"
          inputType="password"
          name="password"
          id="userPassword"
          value={form.password}
          placeholder="••••••••"
          prefix={<LockOutlined />}
          size="large"
          onChange={handleChange}
        />
      </div>

      <div className="login-page__form-actions">
        <div className="login-page__remember">
          <Checkbox id="rememberMe">Keep me signed in</Checkbox>
        </div>
        <Link to="/auth/card/reset-pass" className="login-page__forgot-link">
          Forgot Password?
        </Link>
      </div>

      <AppButton
        htmlType="submit"
        tone="primary"
        size="large"
        loading={loading}
        className="w-full"
      >
        Sign In
      </AppButton>
    </form>
  );
};

export default LoginForm;
